<template>
  <!--<img alt="Vue logo" src="./assets/logo.png">-->
  <div class="main">

    <b-navbar toggleable="lg" type="light" v-if="!scrollPosition" style="position:fixed;z-index:998;width:100%;padding:.5vw;padding-left:5vw;padding-right:5vw;">
      <b-navbar-brand href="#">
        <b-img v-if="$isMobile()" data-aos="fade-up" data-aos-duration="1400" class="toplogomobile" :src="require('./assets/logo-studio-122x122.png')" fluid style="" href='#'></b-img>
        <b-img v-else data-aos="fade-up" data-aos-duration="1400" class="toplogo" :src="require('./assets/logo-studio-122x122.png')" fluid style="" href='#'></b-img>
      </b-navbar-brand>
      <b-navbar-brand v-if="$isMobile()" href="#" class="text-left" >
        <a class="navigation_title text-left" style="font-size:.8em;opacity:1;color:white;" href='#'>
          <span style="font-weight:bold;">STUDIO EST LUMIERE</span>
        </a>
        <a class="navigation_title text-left" style="opacity:1;color:white;" href='#'>
          <p style="font-size:1em;color:white;line-height:50%;">studio photo & vidéo</p>
        </a>
      </b-navbar-brand>
      <b-navbar-brand v-else href="#" class="text-left" >
        <a class="navigation_title text-left" style="font-size:.95em;opacity:1;color:white;" href='#'>
          <span style="font-weight:bold;">STUDIO EST LUMIERE</span>
        </a>
        <a class="navigation_title text-left" style="opacity:1;color:white;" href='#'>
          <p style="font-size:1.09em;color:white;line-height:50%;">studio photo & vidéo</p>
        </a>
      </b-navbar-brand>
      <b-navbar-toggle style="outline:0;border:0;" class="text-center" target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav >
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto text-center">
          <b-navbar-nav >
            <b-nav-item href="#home" :style="[$isMobile() ? {'background': 'black','padding':'1vw'} : {'background': 'none'}]"><a class="navigation_btn" >home</a></b-nav-item>
            <b-nav-item href="#studio" :style="[$isMobile() ? {'background': 'black','padding':'1vw'} : {'background': 'none'}]"><a class="navigation_btn" >studio</a></b-nav-item>
            <b-nav-item href="#descriptif" :style="[$isMobile() ? {'background': 'black','padding':'1vw'} : {'background': 'none'}]"><a class="navigation_btn" >descriptif</a></b-nav-item>
            <b-nav-item href="#tarifs" :style="[$isMobile() ? {'background': 'black','padding':'1vw'} : {'background': 'none'}]"><a class="navigation_btn" >tarifs</a></b-nav-item>
            <b-nav-item href="#contact" :style="[$isMobile() ? {'background': 'black','padding':'1vw'} : {'background': 'none'}]"><a class="navigation_btn" >contact</a></b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>


    <b-navbar toggleable="lg" type="light" v-else style="position:fixed;z-index:998;width:100%;padding:.5vw;padding-left:5vw;padding-right:5vw;background:#a4dde0">
      <b-navbar-brand href="#">
        <b-img v-if="$isMobile()" data-aos="fade-up" data-aos-duration="1400" class="toplogomobile" :src="require('./assets/logo-studio-122x122.png')"
          fluid style="filter: brightness(0);" href='#'></b-img>
        <b-img v-else data-aos="fade-up" data-aos-duration="1400" class="toplogo" :src="require('./assets/logo-studio-122x122.png')"
        fluid style="filter: brightness(0);" href='#'></b-img>
      </b-navbar-brand>

      <b-navbar-brand v-if="$isMobile()" href="#" class="text-left" >
        <a class="navigation_title text-left" style="font-size:.8em;opacity:1;color:black;" href='#'>
          <span style="font-weight:bold;">STUDIO EST LUMIERE</span>
        </a>
        <a class="navigation_title text-left" style="opacity:1;color:white;" href='#'>
          <p style="font-size:1em;color:black;line-height:50%;">studio photo & vidéo</p>
        </a>
      </b-navbar-brand>
      <b-navbar-brand v-else href="#" class="text-left" >
        <a class="navigation_title text-left" style="font-size:.95em;opacity:1;color:black;" href='#'>
          <span style="font-weight:bold;">STUDIO EST LUMIERE</span>
        </a>
        <a class="navigation_title text-left" style="opacity:1;color:white;" href='#'>
          <p style="font-size:1.09em;color:black;line-height:50%;">studio photo & vidéo</p>
        </a>
      </b-navbar-brand>

      <b-navbar-toggle style="outline:0;border:0;" class="text-center" target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav >
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto text-center">
          <b-navbar-nav >
            <b-nav-item href="#home" ><a class="navigation_btn_2" >home</a></b-nav-item>
            <b-nav-item href="#studio" ><a class="navigation_btn_2"  >studio</a></b-nav-item>
            <b-nav-item href="#descriptif" ><a class="navigation_btn_2"  >descriptif</a></b-nav-item>
            <b-nav-item href="#tarifs" ><a class="navigation_btn_2"  >tarifs</a></b-nav-item>
            <b-nav-item href="#contact" ><a class="navigation_btn_2"  >contact</a></b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>


    <b-row align-h='center' id="home" />
    <b-row v-if="imgViewMode" align-h='center' style="position:fixed;top:0;left:0;z-index:999;width:100%;height:100vh;padding:0;margin:0;"
      v-on:click="hideImg" >
      <b-col cols='12' style="background:black;width:100%;height:100vh;padding:0;margin:0;">
        <b-img data-aos="fade-up" data-aos-duration="1000"
          style="width:100%;height:100%;object-fit: contain;padding:2vh;margin:0;z-index:1000;opacity:1;cursor:pointer;"
          :src="photos[currentImgIdx]" fluid-grow />
      </b-col>
    </b-row>



    <b-row align-h='center' style="width:100vw;height:100vh;margin:0;padding:0;" >
      <b-col cols='12' style="width:100vw;height:100vh;margin:0;padding:0;">
        <b-img data-aos="fade-up" data-aos-duration="1000"
          style="width:100vw;height:100vh;margin:0;padding:0;object-fit:cover;"
          :src="require('./assets/main0.png')" fluid-grow />
      </b-col>
    </b-row>



  <!--  <b-col data-aos="fade-up" data-aos-duration="1400" cols="12" class="text-center" style="width:100%;padding:0;margin:0;">
      <b-img style="width:100%;height:100vh;object-fit: cover;padding:0;margin:0;" :src="main_photo" fluid-grow />
    </b-col>
  -->

    <ScrollTopArrow/>

    <b-row align-h='center' id="studio" />
    <b-row v-if="$isMobile()" align-h='center' >
      <b-col cols="12" class="text-center"><h1 class="title">Le Studio</h1></b-col>
      <b-col cols="6" v-for="(img,idx) in photos" v-on:click="showImg(idx)" style="padding:0;margin:0;">
        <b-img class="gallery_img" :src="img" fluid-grow ></b-img>
      </b-col>
    </b-row>
    <b-row v-else align-h='center' style="">
      <b-col cols="12" class="text-center"><h1 class="title">Le Studio</h1></b-col>
      <b-col cols="3" v-for="(img,idx) in photos" v-on:click="showImg(idx)" style="padding:0;margin:0;">
        <b-img class="gallery_img" :src="img" fluid-grow ></b-img>
      </b-col>
    </b-row>

    <b-row align-h='center' id="descriptif" />
    <b-row data-aos="fade-up" data-aos-duration="1250" align-h='center' style="">
      <b-col cols="12" class="text-center"><h1 class="title">Descriptif</h1></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1300" cols="4" class="text-left entry"><h2 class="title">LE STUDIO</h2><p v-html="le_studio"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1300" cols="12" class="text-center entry"><h2 class="title">LE STUDIO</h2><p v-html="le_studio"></p></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1350" cols="4" class="text-left entry"><h2 class="title">ÉQUIPEMENTS</h2><p v-html="equipments_a"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1350" cols="12" class="text-center entry"><h2 class="title">ÉQUIPEMENTS</h2><p v-html="equipments_a"></p></b-col>


      <b-col v-if="!$isMobile()" cols="8" class="text-left"><h2 class="title">MATÉRIEL</h2></b-col>
      <b-col v-else cols="8" class="text-center"><h2 class="title">MATÉRIEL</h2></b-col>

      <b-col cols="12" class="text-left"></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1300" cols="4" class="text-left entry"><p v-html="materiel_a"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1350" cols="12" class="text-center"><p v-html="materiel_a"></p></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1300" cols="4" class="text-left entry"><p v-html="materiel_b"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1350" cols="12" class="text-center"><p v-html="materiel_b"></p></b-col>

    </b-row>


    <b-row align-h='center' id="tarifs" />
    <b-row data-aos="fade-up" data-aos-duration="1250" align-h='center' style="">
      <b-col cols="12" class="text-center"><h1 class="title">Tarifs de location<span style="font-size:.7em"><br/>Matériel inclus</span></h1></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1300" cols="4" class="text-left entry"><h2 class="title">Du lundi au vendredi</h2><p v-html="tarifs_a"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1300" cols="12" class="text-center entry"><h2 class="title">Du lundi au vendredi</h2><p v-html="tarifs_a"></p></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1350" cols="4" class="text-left entry"><h2 class="title">Samedi, dimanche et jours fériés : +20%</h2><p v-html="tarifs_b"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1350" cols="12" class="text-center entry"><h2 class="title">Samedi, dimanche et jours fériés : +20%</h2><p v-html="tarifs_b"></p></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1300" cols="4" class="text-left entry"><h2 class="title"> Assistant Plateau</h2><p v-html="assisstant"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1300" cols="12" class="text-center entry"><h2 class="title"> Assistant Plateau</h2><p v-html="assisstant"></p></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1350" cols="4" class="text-left entry"><h2 class="title">• Fermeture du studio à 22h</h2></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1350" cols="12" class="text-center entry"><h2 class="title">• Fermeture du studio à 22h</h2></b-col>

      <b-col cols="12" class="text-center">
        <!--<h1 @click="showingConditions = !showingConditions" class="title title_link">-->
        <h1 class="title title_link2" v-on:click.stop.prevent="open_PJ_in_newtab()">
          Conditions Générales De Location
        </h1>
      </b-col>

      <!--<b-col v-if="showingConditions && $isMobile()" data-aos="fade-up" data-aos-duration="1350" cols="10" class="text-center"><p v-html="conditions"></p></b-col>
      <b-col v-if="showingConditions && !$isMobile()" data-aos="fade-up" data-aos-duration="1350" cols="9" class="text-center"><p v-html="conditions"></p></b-col>-->

      <b-col cols="12" class="text-left"></b-col>

      <b-col v-if="!$isMobile()" cols="8" class="text-center"><h1 class="title">Fournitures</h1></b-col>
      <b-col v-else cols="12" class="text-center"><h1 class="title">Fournitures</h1></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1300" cols="4" class="text-left entry"><p v-html="fournitures_a"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1300" cols="12" class="text-center entry"><p v-html="fournitures_a"></p></b-col>
      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1350" cols="4" class="text-left entry"><p v-html="fournitures_b"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1350" cols="12" class="text-center entry"><p v-html="fournitures_b"></p></b-col>


      <b-col v-if="!$isMobile()" cols="8" class="text-center"><h1 class="title">Ils nous ont déjà fait confiance. Merci !</h1></b-col>
      <b-col v-else cols="12" class="text-center"><h1 class="title">Ils nous ont déjà fait confiance. Merci !</h1></b-col>

      <b-col v-if="!$isMobile()" data-aos="fade-up" data-aos-duration="1300" cols="9" class="text-center entry"><p style="font-size:1.5em" v-html="clients"></p></b-col>
      <b-col v-else data-aos="fade-up" data-aos-duration="1300" cols="12" class="text-center entry"><p v-html="clients"></p></b-col>

    </b-row>

    <b-row data-aos="fade-up" data-aos-duration="1300" style="background:white;padding-bottom:3vh" >
      <b-col cols="12" v-for="img in plans_photos" class="text-center" style="background:white">
        <b-img style="width:100%;height:50vh;object-fit: contain;padding:0;margin:0;" :src="img" fluid-grow ></b-img>
      </b-col>
      <b-col cols="12" class="text-center" style="background:white">
        <a href="/plan.SEL.pdf.zip" download class="link">Plan / PDF</a>
      </b-col>

    </b-row>

    <b-row align-h='center' id="contact" />
    <b-row data-aos="fade-up" data-aos-duration="1250" align-h='center' style="padding-bottom:5vh">
      <b-col cols="12" class="text-center">
        <h1 class="title">STUDIO EST LUMIERE</h1>
        <p v-html="contact"></p>
      </b-col>
      <b-col cols="12" data-aos="fade-up" data-aos-duration="1250">
        <iframe frameborder="0" style="border:0;width:100%;height:50vh"
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAEIpgj38KyLFELm2bK9Y7krBkz1K-cMq8&amp;q=place_id:ChIJ2SzNB2Nt5kcRfhts6zECpjE"
          allowfullscreen="" />
      </b-col>
    </b-row>

    <b-row align-h="center">
      <b-col cols="12" class="text-center">
        <h1 href="#legal" class="title title_link" style="padding:0;margin:0;"><span  @click="showingLegal = !showingLegal" style="font-size:.9em;">Mentions Légales</span></h1>
      </b-col>
      <b-col v-if="showingLegal && $isMobile()" data-aos="fade-up" data-aos-duration="1350" cols="10" class="text-center" style="padding-bottom:5vh"><p v-html="legal"></p></b-col>
      <b-col v-if="showingLegal && !$isMobile()" data-aos="fade-up" data-aos-duration="1350" cols="9" class="text-center" style="padding-bottom:5vh"><p v-html="legal"></p></b-col>
    </b-row>

    <b-row align-h='center' id="legal"  v-if="showingLegal" />
    <b-row align-h="center" style="padding-top:5vh">
      <b-col cols="12" class="text-center"><p>Suivez-nous !</p></b-col>
      <b-col cols="3" class="text-right"><a href="https://www.instagram.com/studioestlumiere/"><b-img :src="require('./assets/instagram.png')" fluid style="width:50px;height:50px;"></b-img></a></b-col>
      <b-col cols="3" class="text-left"><a href="https://www.facebook.com/studio.est.lumiere/"><b-img :src="require('./assets/facebook.png')" fluid style="width:50px;height:50px;"></b-img></a></b-col>
    </b-row>



    <b-row style="height:10vh"></b-row>

  </div>
</template>

<script>

//import HelloWorld from './components/HelloWorld.vue'
import ScrollTopArrow from './components/ScrollTopArrow'
import axios from 'axios'

export default {
  name: 'App',
  components: { ScrollTopArrow},
  methods: {
    hideImg: function (event) {  this.imgViewMode = false  },
    showImg: function (idx) {  this.currentImgIdx = idx; this.imgViewMode = true  },
    updateScroll() { this.scrollPosition = window.scrollY >= window.innerHeight/10 ? true : false },
    open_PJ_in_newtab: function () { window.open('/CGL.SEL.pdf', '_blank') },
  },
  async mounted () {
    const storage = this.$firebase.storage()
    const listRef = storage.ref('public').child('tVOnCGHNvtPmWeScGoAvS4p9Uyo1')
    window.addEventListener('scroll', this.updateScroll);
    const res = await listRef.listAll()
    for (let itemRef of res.items){
      const url = await itemRef.getDownloadURL()
      if ( itemRef.location.path_.split('/').slice(-1)[0] == '0textcontenu.json' ) {
        /* contenu texte */
        const response = await axios.get(url)
        let data = JSON.parse(response.data)
        this.le_studio = data.le_studio
        this.equipments_a = data.equipments_a
        this.materiel_a = data.materiel_a
        this.materiel_b = data.materiel_b
        this.tarifs_a = data.tarifs_a
        this.tarifs_b = data.tarifs_b
        this.assisstant = data.assisstant
        this.fournitures_a = data.fournitures_a
        this.fournitures_b = data.fournitures_b
        this.clients = data.clients
        this.conditions = data.conditions
        this.legal = data.legal
        this.contact = data.contact
        this.photos_order = JSON.parse(data.photos_order)
        console.log(data.photos_order)
      }
      else if ( itemRef.location.path_.split('/').slice(-1)[0][0] == 'a' ) {this.main_photo = url}
      else if ( itemRef.location.path_.split('/').slice(-1)[0][0] == 'b' ) {
        //this.photos.push(url)
        this.photos_ref[itemRef.location.path_.split('/').slice(-1)[0]] = url
        //instant rearrange

        //this.photos_order = ['b.000','b.001']
        let i = 0
        console.log(this.photos_order)
        for (let p_ref of this.photos_order) {
          //console.log(p_ref)
          //this.photos.push(this.photos_ref[p_ref])
          this.photos[i] = (this.photos_ref[p_ref])
          i++
        }
        this.photos = this.photos.filter(n => n)
      }
      else if ( itemRef.location.path_.split('/').slice(-1)[0][0] == 'c' ) {this.plans_photos.push(url) ; this.plans_photos.sort() }
    }


    //this.photos_order = ['b.000','b.001']
    /*let i = 0
    console.log(this.photos_order)
    for (let p_ref of this.photos_order) {
      console.log(p_ref)
      //this.photos.push(this.photos_ref[p_ref])
      this.photos[i] = (this.photos_ref[p_ref])
      i++
    }*/

    console.log('ok!')

    document.addEventListener('keyup', (evt)=>{ if (evt.keyCode === 27) {this.hideImg()}})

  },
  data: function () {
    return {
      scrollPosition: null,
      main_photo:'',photos:[],plans_photos:[],photos_ref:{},photos_order:[],
      /*
      photos: [
        'http://studioestlumiere.com/assets/images/dsc03697-1-2000x1334.jpg',
        'http://studioestlumiere.com/assets/images/1-2000x1334.jpg',
        'http://studioestlumiere.com/assets/images/dsc03836-2000x1334.jpg',
        'http://studioestlumiere.com/assets/images/dsc03617-2000x1334.jpg',
      ],
      plans_photos: ['http://studioestlumiere.com/assets/images/sel-03-2100x1059.jpg'],
      main_photo: 'http://studioestlumiere.com/assets/images/ouv4-2000x1334.png',
      */
      currentImgIdx:0,
      imgViewMode:false,
      showingConditions:false,
      showingLegal:false,

      le_studio:"• surface plateau 120m2 | L 14m x l 8m <br/>• hauteur sous plafond : 5,50m <br/>• verrière occultable <br/>• puissance électrique: 3 prises 16A <br/>• murs briquettes et poutres métal <br/>• murs béton anthracite texturés <br/>• murs en parpaings blancs <br/>• 2 panneaux en bois peints texturés blancs 2,80m x 1,95m <br/>• escalier et rampe métal <br/>• sol plancher",
      equipments_a:"• kitchenette : café et thé, bouilloire, machine Senseo, micro-ondes, frigo, évier, vaisselle <br/>• coin salon <br/>• loges make-up <br/>• douche <br/>• wc <br/>• table et fer à repasser <br/>• 2 portants, ~40 cintres <br/>• wifi <br/>• enceinte bluetooth <br/>• En option : Steamer Jiffy J-2000i (30€ HT/jour)",
      materiel_a:"• 4 générateurs 1600j Godard, 1 générateur 1000j Godard <br/>• 4 torches <br/>• 1 boîte à lumière sur pont roulant (6 flashs <br/>• 2 générateurs 1600j Godard) <br/>• 1 boîte à lumière Softbox 16 faces avec double diffuse Diamètre 190 cm Profondeur 120 cm + 1 flash Godard (non démontable) <br/>• 1 flash Fresnel <br/>• 1 câble synchro,( 1 déclencheur radio Kaiser ) <br/>• 1 opalite blanche 70 cm <br/>• nid d’abeille pour opalite <br/>• 3 boîtes à lumière souples (100×85, 56×56, 115×38) <br/>• 1 boule chinoise <br/>• 2 parapluies blancs diamètre 100 cm et 2 parapluies blancs diffusants 80 cm <br/>• bols reflecteurs 16cm, 18cm, 23cm",
      materiel_b:"• nids d’abeille <br/>• 8 pieds (lumières) <br/>• 2 girafes <br/>• 2 autopoles <br/>• 3 gueuses métal <br/>• 3 gueuses sable <br/>• 4 clamps <br/>• pinces <br/>• 5 portes-poly <br/>• 9 réflecteurs/poly (7 blancs, 3 noirs & blancs) <br/>• 2 cubes bois 40X40 <br/>• 2 colonnes en bois blanc 115 X 40 <br/>• 6 marches-cubes empilables en bois <br/>• 1 ventilateur <br/>• Liste détaillée du matériel sur demande.",
      tarifs_a:"• La journée (9:00-19:00) : 400€ HT <br/>• La demi-journée (9:00-14:00/14:00-19:00) : 300€ HT <br/>• Frais de nettoyage : 30€ HT <br/>• Heure supplémentaire : 50€ HT <br/>• TVA 20%",
      tarifs_b:"• La journée : 480€ HT <br/>• La demi-journée : 360€ HT <br/>• Frais de nettoyage : 30€ HT <br/>• Heure supplémentaire : 60€ HT <br/>• TVA 20%",
      assisstant:"• Forfait 2 heures : 80 €<br/>• Demi-journée : 150 €<br/>• Journée 250 €",
      fournitures_a:"• Fond blanc <br/>• Largeur 3,50m : 20€ HT le mètre déroulé au sol <br/> <br/>• Fonds couleurs <br/>• Largeur 2,72m : 15€ HT le mètre déroulé au sol",
      fournitures_b:"• Toiles peintes sol grises, 6m x 3m : 30€ HT <br/>• Steamer Jiffy J-2000i : 30€ HT",
      clients:'Vogue • Marie-Claire • Harper’s Bazaar • Le Figaro Magazine • Madame Figaro • Paris Capitale • Cash Investigation • Sony Music • France 2 • Dolce & Gabbana • Lancôme • Uniqlo • Zapa • Courir • L’Occitane • Cash Investigation • Elise Lucet • Philippe Katerine • Christine and the Queens • Dadju • Benabar • Béatrice Dalle<br/>• Joey Starr • Patricia Petibon • Yvan Cassar • Nathalie Dessay • Maxime le Forestier • Kendji Girac ...',
      conditions:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque nisi felis, tempus gravida eleifend ac, interdum vitae massa. Suspendisse potenti. In rhoncus, erat et elementum dictum, mauris urna pharetra nisi, et dignissim est odio vel mi. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In ullamcorper tortor ipsum, a dapibus ante faucibus non. Aenean volutpat turpis nec libero rhoncus, eu tincidunt elit malesuada. Phasellus viverra feugiat metus sed mattis. Quisque consequat elementum mollis',
      legal:'Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique, dite L.C.E.N., nous portons à la connaissance des utilisateurs et visiteurs du site https://www.studioestlumiere.com les informations suivantes. <br/>Informations légales: • Statut du propriétaire : Entrepreneur individuel • Nom : Studio Est Lumière • Adresse : 154 rue Etienne Marcel 93100 Montreuil • Tél. : 01 48 70 12 73 • SIRET : 404 391 260 00027 • Numéro TVA intracommunautaire : FR30404391260 • Adresse de courrier électronique : <a href="mailto:contact@studioestlumiere.com">contact@studioestlumiere.com</a> • Le créateur du site est : Laurent Benaïm • Le Responsable de la publication : Laurent Benaïm • Contacter le responsable de la publication : <a href="mailto:contact@studioestlumiere.com">Cliquez ici</a> • Le responsable de la publication est une personne physique • Le Webmaster est : Laurent Benaïm • L’hébergeur du site est : Firebase',
      contact:"154 Rue Etienne Marcel 93100 Montreuil / T. 01 48 70 12 73 <br/>A 800m de la Porte de Montreuil <br/><a href='mailto:contact@studioestlumiere.com'>contact@studioestlumiere.com</a><br/><br/>METRO <br/>Ligne 9 - Robespierre <br/><br/>BUS <br/>102 - Sorins <br/>318 - Robespierre",
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Kumbh+Sans:wght@300;400;700&display=swap');
html,body {
  width:100vw;
  max-width:100vw;
  overflow-x:hidden;
}
* {
  font-family: 'Kumbh Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  word-break: break-word;
  line-height:2em;
  scroll-behavior: smooth;

  transition: all 0.4s ease;
}
*::selection {
  background:pink;
}

a.link{
  font-size:1.3em;
  color:#444;
  text-decoration:none;
}
a.link:hover{
  color:black;
  text-decoration:none;
}
a.link:visited{
  text-decoration:none;
}

.navbar_normal{
  backgroud:none;padding-left:10vw;padding-right:10vw;
}
.toplogo{
  width:90px;
  height:90px;
  filter: brightness(1);
  transition-duration: 2s;
}
.toplogo:hover{filter: brightness(0.95);}
.toplogomobile{
  width:70px;
  height:70px;
  filter: brightness(1);
  transition-duration: 2s;
  margin:0;padding:0;
}
.navigation_title{
  color:black;
  font-size:.8em;
  text-align:left;
  transition-duration:0.1s;
  line-height:50%;
}
a.navigation_title,a.navigation_title:hover,a.navigation_title:visited{  text-decoration:none; }
a.navigation_title:hover{color:#333;transition-duration:0.1s}

.navigation_btn{
  font-size:1.2em;
  opacity:1;
  color:white;
}
.navigation_btn_2{
  font-size:1.2em;
  opacity:1;
  color:black;
}
a.navigation_btn:hover,a.navigation_btn_2:hover{
  color:#bf274d;
  text-decoration:none;
}

h1.title {
  font-size:3em;
  font-weight:bold;
  padding:2vh;
  margin-top:5vh;
}

.title_link{color:#333;cursor:pointer;}
.title_link:hover{color:#bf274d;cursor:pointer;}

.title_link2{cursor:pointer;}
.title_link2:hover{color:#bf274d;cursor:pointer;}

h2.title {
  font-size:2em;
  padding:1vh;
  padding-left:0;
}
p {
  font-size:1.25em;
  letter-spacing:0.07em;
  color:black;
}
.main {
  background: #a4dde0;
  min-height:100vh;
  max-width:100%;
  width:100%;
  padding:0;margin:0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}
.entry{
  padding:1vh;
  margin:1vh;
}
.gallery_img{
  object-fit: cover;padding:0;margin:0;
}
.gallery_img:hover{
  filter: brightness(0.5);
  cursor: pointer;
}

#studio:before,#descriptif:before,#tarifs:before,#contact:before{height: 5vh; content: ""; display:block;}

::-webkit-scrollbar {
    width: 0px;
    heigth:0px;
}

::-webkit-scrollbar-track
{
	-webkit-box-shadow: none;
	background-color: none;
}

::-webkit-scrollbar
{
	width: 0px;
  heigth:0px;
	background-color: 0;
}

::-webkit-scrollbar-thumb
{
	background-color: #000000;
  height:0px;
  width:0px;
}



</style>
